import styled from '@emotion/styled'
import { breakpoint, calcRem, colors } from '../../..'

export const StyledMainView = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: colors.thenightly.neutral[100],
    margin: calcRem(10, 10, 0),
    padding: calcRem(8),
    borderRadius: calcRem(12),
    columnGap: calcRem(8),
    alignItems: 'center',
    justifyContent: 'space-around',
    '&:hover': {
        cursor: 'pointer',
        borderColor: colors.thenightly.custom[10],
    },
    [breakpoint('sm')]: {
        margin: calcRem(10, 0, 0),
    },
}))

export const StyledOpenedMainView = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.thenightly.neutral[100],
    margin: calcRem(10, 10, 0),
    padding: calcRem(16),
    borderRadius: calcRem(12),
    rowGap: calcRem(16),
    alignItems: 'flex-start',
    [breakpoint('sm')]: {
        margin: calcRem(10, 0, 0),
    },
}))

export const StyledAuthorsView = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    columnGap: calcRem(8),
    alignItems: 'center',
    '&:hover': {
        cursor: 'pointer',
    },
}))

export const StyledImageView = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: calcRem(12),
    '& > *:not(:first-of-type)': {
        marginLeft: '-5px',
    },
}))

export const StyledOverlappingImageWrapper = styled('div')(({ theme }) => ({
    marginLeft: theme.margins.xs,
}))

export const StyledLessButton = styled('button')(
    ({ theme }) => ({
        width: '100%',
        background: 'transparent',
        border: `1px solid ${colors.thenightly.live[50]}`,
        borderRadius: calcRem(8),
        padding: calcRem(4, 0),
        display: 'flex',
        flexDirection: 'row',
        gap: calcRem(8),
        justifyContent: 'center',
        transition: '0.2s ease',
        '&:hover': {
            cursor: 'pointer',
            borderColor: colors.thenightly.custom[10],
        }
    }),
)

export const StyledLessButtonText = styled('p')(({ theme }) => ({
    color: colors.thenightly.live.default,
    fontFamily: theme.fonts.sansSerif,
    margin: 0,
    lineHeight: '150%',
}))

export const TitleText = styled('p')(({ theme }) => ({
    fontSize: calcRem(20),
    fontWeight: 'bold',
    color: colors.thenightly.live.default,
    fontFamily: theme.fonts.sansSerif,
    margin: 0,
}))

// Author Image
export const StyledSquareIcon = styled('i')<{
    size?: number
    color?: string
    rotate?: number
}>(({ theme, size, color, rotate }) => ([
    {
        display: 'flex',
        width: size ?? 24,
        height: size ?? 24,
        color: color ? color : colors.thenightly.neutral[70],
    },
    rotate && {
        transform: `rotate(${rotate}deg)`,
    }
]
))

export const StyledAuthorImageDiv = styled('div')<{ size: number }>(
    ({ theme, size }) => ({
        backgroundColor: colors.black,
        width: size,
        height: size,
        borderRadius: size * 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
)

export const StyledAuthorImage = styled('img')<{ size: number, isShadowView?: boolean }>(
    ({ size, isShadowView }) => ({
        width: size,
        height: size,
        borderRadius: size * 2,
        ...(isShadowView && {
            marginLeft: '-5px',
        }),
    }),
)

export const StyledNoImageGradient = styled('span')<{ size: number }>(
    ({ size }) => ({
        borderRadius: size * 2,
        width: size,
        height: size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
)

export const StyledShadow = styled('div')<{ size: number }>(
    ({ theme, size }) => ({
        backgroundColor: colors.thenightly.neutral[10],
        borderRadius: size * 2,
        boxShadow: '0 0 0 2px rgba(22, 22, 22, 0.5)',
    }),
)

// Author Meta
export const StyledAuthorMeta = styled('div')(({ theme }) => ({
    flexDirection: 'row',
    borderRadius: theme.margins.xs,
    columnGap: theme.margins.xs,
    alignItems: 'center',
}))

export const StyledNameText = styled('p')(({ theme }) => ({
    color: colors.thenightly.neutral[0],
    fontFamily: theme.fonts.sansSerif,
    lineHeight: '150%',
    margin: 0,
}))

// Reporting Live Text
export const StyledNames = styled('p')(({ theme }) => ({
    color: colors.thenightly.neutral[0],
    display: 'flex',
    flex: 1,
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(12),
    margin: calcRem(10, 0),
    [breakpoint('xs')]: {
        fontSize: calcRem(16),
    },
}))

export const StyledLiveText = styled('span')(({ theme }) => ({
    color: colors.thenightly.live.default,
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 'bold',
    marginLeft: calcRem(6),
}))

export const StyledShadowView = styled('div')(({ theme }) => ({
    borderRadius: calcRem(48),
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: calcRem(-5),
    backgroundColor: colors.thenightly.live[90],
    boxShadow: '0 0 2.4px 0 rgba(0, 0, 0, 0.50)',
}))

export const StyledCountText = styled('p')(({ theme }) => ({
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(10),
    color: colors.thenightly.live[10],
}))